@if (available()) {
  <section class="p-8" aria-label="Version history">
    <h2>Version history</h2>
    <p
      class="mb-8 flex items-start gap-6 rounded-md border border-border bg-primary-50 px-7 py-6 text-sm leading-10 text-secondary-800"
    >
      <app-icon name="refresh" size="m" class="shrink-0 text-primary-600" aria-hidden="true" />
      <span>Restoration creates a new version. Current ownership and access remain unchanged.</span>
    </p>
    @if (failure()) {
      <p role="alert">{{ failure() }}</p>
      @if (!confirmation()) {
        <button type="button" [disabled]="busy()" (click)="retry()">Retry</button>
      }
    }
    @if (loading()) {
      <p role="status">Loading versions…</p>
    } @else if (!failure() && !rows().length) {
      <p>No versions yet</p>
    }
    <ul class="list-none p-0">
      @for (row of rows(); track row.version) {
        <li class="mb-6 rounded-lg border border-border p-6">
          <strong class="text-sm">Version {{ row.version }}</strong>
          @if (row.version === current()) {
            <strong
              class="ml-2 inline-flex rounded bg-primary-50 px-2 py-1 text-[11px] leading-7 font-medium text-primary-600"
              >Current</strong
            >
          }
          <p class="mt-2 text-xs leading-12 text-secondary-500">
            {{ row.author?.name ?? 'Former member' }} ·
            <time [attr.datetime]="row.at">{{ row.at | dateFormat: 'relativeDate' }}</time>
          </p>
          @if (row.restoredFrom !== null) {
            <p class="text-xs leading-12 text-secondary-500">Restored from version {{ row.restoredFrom }}</p>
          }
          @if (row.review) {
            <p class="text-xs leading-12 text-secondary-500">{{ review(row) }}</p>
          }
          <div class="flex flex-wrap items-center gap-4">
            <app-button2
              type="button"
              appearance="secondary"
              size="m"
              [disabled]="busy()"
              (click)="download(row.version)"
              >Download this version</app-button2
            >
            @if (canEdit() && row.version !== current()) {
              <app-button2
                type="button"
                appearance="secondary"
                size="m"
                data-restore
                [disabled]="busy()"
                (click)="askRestore(row.version)"
                >Restore content</app-button2
              >
            }
          </div>
          @if (confirmation() === row.version) {
            <section aria-label="Confirm restore">
              <p>
                Only the name, description and file content will change. Ownership, access, marks and folder stay the
                same.
              </p>
              <button type="button" #restoreCancel [disabled]="busy()" (click)="cancel()">Cancel</button>
              <button type="button" [disabled]="busy() || !canEdit()" (click)="confirmRestore()">
                Confirm restore
              </button>
            </section>
          }
        </li>
      }
    </ul>
    @if (total() > 25 || page()) {
      <nav aria-label="Version pages">
        <button type="button" [disabled]="page() === 0 || loading() || busy()" (click)="previous()">Previous</button>
        <button type="button" [disabled]="(page() + 1) * 25 >= total() || loading() || busy()" (click)="next()">
          Next
        </button>
      </nav>
    }
  </section>
}
